import { useMemo } from 'react'

/** @type {import('Simple/types.js').useDataTransform} */
export default function useDataTransform(props, data) {
  return useMemo(() => {
    if (!data?.length) return data

    return data[0].appointment_procedures
      .flatMap(
        appointment_procedure =>
          appointment_procedure.procedure.procedure_misc_fee_charge_templates
      )
      .map(item => item.misc_fee_charge_template)
      .map(charge_template => ({
        id: crypto.randomUUID(),
        type_id: charge_template.id,
        name: charge_template.name,
        amount: charge_template.price,
        is_included_in_insurance_claim:
          charge_template.is_included_in_insurance_claim,
        insurance_code_id: charge_template.insurance_code_id,
        affecting_production_report:
          charge_template.affecting_production_report,
        requires_tooth_details: charge_template.requires_tooth_details,
      }))
  }, [data])
}
